<template>
  <b-sidebar
    v-if="isOpenLocal"
    v-model="isOpenLocal"
    id="sidebar-right-bdr-dict"
    :title="editedItemLocal.id ? `Редактирование свойства #${editedItemLocal.id}` : 'Добавление свойства'"
    right
    backdrop
    shadow
    width="45em"
    backdrop-variant="dark"
    no-close-on-backdrop
  >
  <!-- @change="closeSidePanelCallback()" -->
    <div class="d-block">  
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-name">Название из файла</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
              v-model="editedItemLocal.name_from_file"
              id="input-name"
              size="sm"
          />
        </b-col>
      </b-row>
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-reference_id">Привязка к свойству из сводной таблицы</label>
        </b-col>
        <b-col sm="9">
            <b-form-select 
                v-model="editedItemLocal.bdr_dictionary_id" 
                :options="parentOptions"
                size="sm"
            ></b-form-select>
        </b-col>
      </b-row>
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-unit">Признак (формат 100%B2C или 50%B2C,50%B2B)</label>
        </b-col>
        <b-col sm="9">
          <b-form-input
              v-model="editedItemLocal.unit_percent"
              id="input-name"
              size="sm"
          />
        </b-col>
      </b-row>      
      <b-row class="my-2" style="align-items: center;">
        <b-col sm="3">
          <label for="input-unit">Пропускать строки с таким наименованием?</label>
        </b-col>
        <b-col sm="9">
          <b-form-checkbox
            id="always_pass"
            v-model="editedItemLocal.always_pass"
            name="always_pass"
            :value="1"
            :unchecked-value="0"
          >
            Пропускать
          </b-form-checkbox>
        </b-col>
      </b-row>      
      <div class="d-flex mt-2 mb-2">
        <b-button
            size="md"
            class="ml-auto btn btn-secondary"
            @click="closeSidebar()"
            :disabled="loading"
        >
            Отмена
        </b-button>
        <b-button
            size="md"
            class="ml-2 btn btn-primary"
            @click="saveElement()"
        >
            Сохранить <b-icon v-if="loading" icon="arrow-repeat" scale="1.2" aria-label="Reload" :animation="loading ? 'spin' : ''"></b-icon>
        </b-button>
      </div>
    </div>     
  </b-sidebar>   
</template>

<script>
import { API_BDR_1C_DICTIONARY, API_BDR_DICTIONARY } from '@/constants';

const initialDictionaryElement = () => (
    {
      name_from_file: '',
      bdr_dictionary_id: '',
      unit_percent: '',
      file_name: '',
      r_index: null,                
      always_pass: 0,
      property: {}
    }
);

export default {
  name: 'BdrDictionarySidebar',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    editedItem: {
      type: Object,
      default: () => (
        {
          fault: {},
          name_from_file: '',
          file_name: '',
          r_index: null,                
          always_pass: 0,
          bdr_dictionary_id: '',
          unit_percent: '',
          property: {}
        }
      ),
    },
  },
  components: {
  },
  // watch: {
  //   editedItem: {
  //       deep: true,
  //       handler(editedItem) {
  //         console.log("IN!", editedItem)
  //         console.log("isOpenLocal", this.isOpenLocal);
  //       },
  //   }, 
  // },  
  computed: {
    isOpenLocal: {
      get: function() {
        return this.isOpen
      },
      set: function(value) {
        this.$emit('update:isOpen', value)
      }
    },
    editedItemLocal: {
      get: function() {
        return this.editedItem
      },
      set: function(value) {
        // this.$emit('update:editedItem', value)
      }
    },      
  },  
  data() {
    return {
      loading: false,
      parentOptionsData: [],
      parentOptions: [],
    }
  },
  mounted() {
    this.getDictionary();
  },
  methods: {
    getDictionary() {
      axios.get(`${API_BDR_DICTIONARY}?easylist=true`).then(({ data }) => {
          this.parentOptionsData = data;
          this.formNestedParentOptions(this.parentOptionsData, 0, '')
          this.loading = false;
      });        
    },
    formNestedParentOptions(dictionary, parent_id, addsymb = '') {
        dictionary.forEach((reference, index) => {
            let addSmth = '';
            if (reference.external_number) {
                addSmth = `, ${reference.external_number}`
            }
            this.parentOptions.push({
                value: reference.id,
                text: `${addsymb}${reference.id}: ${reference.name} (${reference.unit}${addSmth})`
            });

            if (reference.children && reference.children.length > 0) {
                this.formNestedParentOptions(reference.children, reference.id, addsymb + '-');
            }
        })
    },
    closeSidebar() {
      this.isOpenLocal = false;
    },
    saveElement() {
      this.loading = true;
      if (this.editedItemLocal.id) {
        axios.put(`${API_BDR_1C_DICTIONARY}/${this.editedItemLocal.id}`, this.editedItemLocal)
        .then((property) => {
          this.$emit('updateItem', this.editedItemLocal, property);
          this.editedItemLocal = initialDictionaryElement();
          this.loading = false;
          this.closeSidebar();
        });
      } else {
        axios.post(`${API_BDR_1C_DICTIONARY}`, this.editedItemLocal)
        .then((property) => {
          this.$emit('updateItem', this.editedItemLocal, property);
          this.editedItemLocal = initialDictionaryElement();
          this.loading = false;
          this.closeSidebar();
        });
      }
    },    
  },  
}
</script>
